var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptimalProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Success (green), SIze=16, Type=Fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primary-shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.445312 8.3457C0.445312 3.92743 4.02703 0.345703 8.44531 0.345703C10.567 0.345703 12.6019 1.18856 14.1022 2.68885C15.6025 4.18914 16.4453 6.22397 16.4453 8.3457C16.4453 12.764 12.8636 16.3457 8.44531 16.3457C4.02703 16.3457 0.445312 12.764 0.445312 8.3457ZM8.22931 11.2337L11.8853 6.4337V6.4097C12.0597 6.18105 12.0988 5.87676 11.9879 5.61145C11.8771 5.34613 11.6331 5.16011 11.3479 5.12345C11.0627 5.08678 10.7797 5.20505 10.6053 5.4337L7.58131 9.4337L6.27731 7.7697C6.10154 7.54391 5.81866 7.42905 5.53523 7.46838C5.2518 7.50771 5.01088 7.69525 4.90323 7.96038C4.79557 8.2255 4.83754 8.52791 5.01331 8.7537L6.96531 11.2417C7.11797 11.4349 7.35109 11.547 7.59731 11.5457C7.84491 11.5451 8.07828 11.4299 8.22931 11.2337Z",
    fill: "#31BF7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimalProtection);
export default __webpack_public_path__ + "static/media/optimal_protection.ea042a62ddf1ddae3531cfc81d46b3ed.svg";
export { ForwardRef as ReactComponent };